import { ERROR_TYPE } from '@/features/game-window-integration/helpers/error-mapping';
import { ProviderAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/contracts';
import { runProcessError } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/process-error';
import { GenericEvents } from '@/features/game-window-integration/providers/generic-provider/types';

export const whiteHatAdaptor: ProviderAdaptor = {
  eventsRemap: {
    [GenericEvents.SPIN_IN_PROGRESS]: 'gameBusy',
    [GenericEvents.SPIN_IN_PROGRESS_ENDED]: 'gameNotBusy',
    [GenericEvents.AUTOPLAY_STOP]: 'stopAutoplay',
    [GenericEvents.TOGGLE_PAYTABLE]: 'showPaytable',
    [GenericEvents.TOGGLE_HELP]: 'showHelp',
  },

  errorCodesRemap: {
    INVALID_SESSION: ERROR_TYPE.SESSION_EXPIRED,
    SESSION_EXPIRED: ERROR_TYPE.SESSION_EXPIRED,
    SESSION_LIMIT_REACHED: ERROR_TYPE.GENERIC,
    INSUFFICIENT_FUNDS: ERROR_TYPE.INSUFFICIENT_FUNDS,
    1: ERROR_TYPE.CONNECTION_LOST,
    RESTART: ERROR_TYPE.UNKNOWN,
    nonFatal: ERROR_TYPE.GENERIC_DISMISSABLE,
    lossLimit: ERROR_TYPE.UNKNOWN,
  },

  errorMessages: {},

  adaptInbound(providerData) {
    if (providerData.errorInfo) {
      providerData.payload = providerData.errorInfo;
    }
    return providerData;
  },

  adaptOutbound(eventToProvider, notify, payload) {
    const isToggleSound = eventToProvider === GenericEvents.TOGGLE_SOUND;
    const isMuted = Boolean((payload as { mute?: boolean } | undefined)?.mute);

    let type = eventToProvider;
    if (isToggleSound) {
      type = isMuted ? GenericEvents.SOUND_OFF : GenericEvents.SOUND_ON;
    }

    return {
      type,
      ...(notify && { stateChangeMessageType: eventToProvider }),
    };
  },

  processError(error) {
    return runProcessError(error, this.errorCodesRemap, this.errorMessages);
  },
};
